import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_ORDER_CANCEL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_ORDER_CANCEL_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_ORDER_CANCEL_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/orders/${id}/cancel`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
